import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["value", "textContent"]

import {computed, inject, ref} from "vue";
import Icon from "../Icon/Icon.vue";
import {IconName} from "../Icon/icons";
import {DrawerScroll} from "./Drawer";
import Dropdown from "./Dropdown.vue";

export interface DrawerOption<T> {
  value: T;
  title: string;
}

interface Props {
  title?: string;
  icon?: IconName;
  testId?: string;
  nested?: boolean;
  nestedFlush?: boolean;
  options: DrawerOption<U>[];
  openToLeft?: boolean;
  default?: string;
  scrollable?: boolean;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownSingle',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    icon: {},
    testId: {},
    nested: { type: Boolean },
    nestedFlush: { type: Boolean },
    options: {},
    openToLeft: { type: Boolean },
    default: {},
    scrollable: { type: Boolean },
    disabled: { type: Boolean }
  }, {
    "modelValue": {required: true},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const selected = _useModel<U>(__props, "modelValue");
const open = ref<boolean>(false);

const hasError = inject('fieldHasError', computed(() => false));
const fieldLabelId = inject('fieldLabelId', undefined);

function select(value: U): void {
  selected.value = value;
  open.value = false;
}

const title = computed((): string => {
  if (props.title) {
    return props.title;
  }
  return props.options.find(option => option.value === selected.value)?.title || props.default || '';
});

const scroll = computed((): DrawerScroll => {
  if (props.scrollable) {
    return 'scrollable';
  }
  return 'none';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Dropdown, {
      title: title.value,
      icon: props.icon,
      "test-id": props.testId,
      nested: props.nested,
      "nested-flush": props.nestedFlush,
      openToLeft: props.openToLeft,
      scroll: scroll.value,
      "has-error": _unref(hasError),
      disabled: props.disabled,
      "no-space": "",
      open: open.value,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (select(option.value)),
            class: _normalizeClass(["cursor-pointer text-nowrap px-2 py-2 rounded", {accent: selected.value === option.value}])
          }, [
            (selected.value === option.value)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 0,
                  name: "dropdownOptionSelected",
                  class: "text-primary mr-1"
                }))
              : _createCommentVNode("v-if", true),
            _createTextVNode(" " + _toDisplayString(option.title), 1 /* TEXT */)
          ], 10 /* CLASS, PROPS */, _hoisted_1))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title", "icon", "test-id", "nested", "nested-flush", "openToLeft", "scroll", "has-error", "disabled", "open"]),
    _withDirectives(_createElementVNode("select", {
      class: "absolute opacity-0 pointer-events-none",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selected).value = $event)),
      id: _unref(fieldLabelId)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          value: option.value,
          textContent: _toDisplayString(option.title)
        }, null, 8 /* PROPS */, _hoisted_3))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 8 /* PROPS */, _hoisted_2), [
      [_vModelSelect, selected.value]
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})